<div class="relative flex py-5 items-center mx-auto max-w-screen-xl">
    <div class="flex-grow border-t border-slate-400"></div>
</div>
